import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "./useWeb3";
import environment from "../utils/Environment";
import { dopContract } from "../utils/contractHelpers";

export const DopClaim2 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const IsClaimed = useCallback(
    async (account, claimAddress) => {
      const contract = dopContract(claimAddress, web3);
      try {
        var approved;
        approved = await contract.methods.isClaimed(account).call();
        return approved;
      } catch (err) {
        console.log("aganssaf", err);
      }
    },
    [account]
  );

  return { IsClaimed2: IsClaimed };
};

export default DopClaim2;
